import ServerManager from "./ServerManager"
import storeDispatcher from "../storeDispatcher"
import store from "../storeDispatcher/store";
import ObjectData from "../dataModel/ObjectData";


function waitMS(ms = 1000) {
    return new Promise((resolve) => {
        setTimeout(() => resolve(true), ms)
    });
}


export default class StoreManager {

    static server = ServerManager.productiveConnection;
    static serverSB = ServerManager.sandboxConnection;
    static currentServer = this.server;

    static downloadRequested = {};
    static currentDownloads = {};

    static async downloadObject(objectId, fromObjectId) {
        await this._waitAndRegisterDownload(objectId);

        let object = await this.server.getObject(objectId, fromObjectId);
        if (!object) {
            this.currentServer = this.serverSB;
            object = await this.currentServer.getObject(objectId, fromObjectId);
        }

        this._downloadingFinished(objectId);
        if (!object) return;

        console.log(object);
        storeDispatcher.objectUpdate(object);

        // Check additional avatar, downloading fileData
        object.mediaEntries
            .filter(it => it.isAvatar)
            .forEach(avatarMedia => {
                if (avatarMedia.fileId && !avatarMedia.fileData) {
                    StoreManager.downloadSoundtrackData(avatarMedia.fileId)
                }
            });

        if (object.isContainerObject) {
            this.downloadChildrenAvatars()
                .then();
        }

        return object;
    }

    static async downloadSoundtrackData(fileId) {
        const object = {...store.getState().object};

        if ( !(await this._waitAndRegisterDownload(fileId)) ) return;

        const data = await this.currentServer.getSoundtrackData(fileId);
        // this.downloadRequested[fileId] = true;

        if (!data) {
            this._downloadingFinished(fileId);
            return alert("Error. Can't play this.");
        }

        let modifiedSpeek;
        object.mediaEntries.forEach((item, i) => {
            if (item.fileId === fileId) {
                item.fileData = data;
                modifiedSpeek = item;

                if (item.avatarId && !item.avatarData && !this.downloadRequested[item.avatarId]) {
                    console.log("Additional avatar downloading ...");
                    this.downloadMediaData(item.avatarId);
                }
            }
        });

        storeDispatcher.objectUpdate(new ObjectData(object));

        this._downloadingFinished(fileId);
        return modifiedSpeek || null;
    }

    static async changeMediaProgress(value) {
        return await storeDispatcher.changeMediaProgress(value);
    }

    static async downloadMediaData(mediaId) {
        const object = {...store.getState().object};

        const media = object.mediaEntries.find(it => it.mediaId === mediaId);
        if (!media) return;

        return await this.downloadSoundtrackData(media.fileId);
    }

    static async __waitForDownloads() {
        let repeatCount = 0;

        while (Object.keys(this.currentDownloads).length > 0) {
            await waitMS(300);
            repeatCount++;
            if (repeatCount > 6) break;
        }

        return true;
    }

    static async _waitAndRegisterDownload(taskId) {
        if (this.downloadRequested[taskId]) {
            // console.log("Trying to download resource twice");
            return false;
        }

        await this.__waitForDownloads();
        this.currentDownloads[taskId] = true;
        this.downloadRequested[taskId] = true;

        return true;
    }

    static _downloadingFinished(taskId) {
        delete this.currentDownloads[taskId];
    }

    static changePlaying(value = false) {
        storeDispatcher.changePlaying(value);
    }

    static async downloadChildrenAvatars() {
        const object = {...store.getState().object};
        if (!object.childrenList) return;

        for (const child of object.childrenList) {
            const avatarId = child.avatarId;

            const avatarMedia = child.mediaEntries.find(it => it.mediaId === avatarId);
            if (!avatarMedia) continue;

            const fileId = avatarMedia.fileId;

            if (avatarId && !child.avatarData) {
                if (!await this._waitAndRegisterDownload(fileId)) continue;

                const data = await this.currentServer.getSoundtrackData(fileId, 150);
                this._downloadingFinished(fileId);
                if (!data) continue;

                avatarMedia.fileData = data;
                storeDispatcher.objectUpdate(new ObjectData(object));
            }

        }

        // console.log(object);
        storeDispatcher.objectUpdate(new ObjectData(object));
    }

    static async downloadObjectToList(objectId) {
        const objectList = {...store.getState().objectList};

        if ( !(await this._waitAndRegisterDownload(objectId)) ) return;

        let object = await this.server.getObject(objectId);
        if (!object) {
            this.currentServer = this.serverSB;
            object = await this.currentServer.getObject(objectId);
        }
        this._downloadingFinished(objectId);
        if (!object) return;

        objectList[objectId] = object;
        storeDispatcher.objectListUpdate(objectList);

        return object;
    }

    static addParameters(params) {
        const oldParams = store.getState().parameters;
        storeDispatcher.setParameters({...oldParams, ...params});
    }

    static rewriteParameters(params) {
        storeDispatcher.setParameters({...params});
    }

}